/**
 * @flow
 * @relayHash 50d5791ecd63c0b2776ebe86ca60414c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Suggest_suggestSearch$ref = any;
export type SuggestRefetchQueryVariables = {|
  keyword?: ?string,
  langCode?: ?string,
|};
export type SuggestRefetchQueryResponse = {|
  +suggestSearch: ?{|
    +$fragmentRefs: Suggest_suggestSearch$ref
  |}
|};
export type SuggestRefetchQuery = {|
  variables: SuggestRefetchQueryVariables,
  response: SuggestRefetchQueryResponse,
|};
*/


/*
query SuggestRefetchQuery(
  $keyword: String
  $langCode: String
) {
  suggestSearch {
    ...Suggest_suggestSearch_4ks8V8
  }
}

fragment Suggest_suggestSearch_4ks8V8 on SuggestSearch {
  search(keyword: $keyword, langCode: $langCode) {
    productKeyword
    productType
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "keyword",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "langCode",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "keyword",
    "variableName": "keyword"
  },
  {
    "kind": "Variable",
    "name": "langCode",
    "variableName": "langCode"
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SuggestRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "suggestSearch",
        "storageKey": null,
        "args": null,
        "concreteType": "SuggestSearch",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Suggest_suggestSearch",
            "args": (v1/*: any*/)
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SuggestRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "suggestSearch",
        "storageKey": null,
        "args": null,
        "concreteType": "SuggestSearch",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "search",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "SuggestProduct",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "productKeyword",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "productType",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "SuggestRefetchQuery",
    "id": null,
    "text": "query SuggestRefetchQuery(\n  $keyword: String\n  $langCode: String\n) {\n  suggestSearch {\n    ...Suggest_suggestSearch_4ks8V8\n  }\n}\n\nfragment Suggest_suggestSearch_4ks8V8 on SuggestSearch {\n  search(keyword: $keyword, langCode: $langCode) {\n    productKeyword\n    productType\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'babc90c7ac43985c70d5e53f2b726cc0';
module.exports = node;
